import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-home-living-pnw',
    templateUrl: './home-living-pnw.component.html',
    styleUrls: ['./home-living-pnw.component.css'],
})
export class HomeLivingPnwComponent implements OnInit {
    constructor() {}

    ngOnInit() {}
}



// WEBPACK FOOTER //
// /Users/masonpimentel/Repos/mason-blog/src/app/home-living-pnw/home-living-pnw.component.ts